/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RecordingManualChangesResponseFieldsRecordingTitle } from './RecordingManualChangesResponseFieldsRecordingTitle';
import {
    RecordingManualChangesResponseFieldsRecordingTitleFromJSON,
    RecordingManualChangesResponseFieldsRecordingTitleFromJSONTyped,
    RecordingManualChangesResponseFieldsRecordingTitleToJSON,
} from './RecordingManualChangesResponseFieldsRecordingTitle';
import type { RecordingManualChangesResponseFieldsRecordingVersion } from './RecordingManualChangesResponseFieldsRecordingVersion';
import {
    RecordingManualChangesResponseFieldsRecordingVersionFromJSON,
    RecordingManualChangesResponseFieldsRecordingVersionFromJSONTyped,
    RecordingManualChangesResponseFieldsRecordingVersionToJSON,
} from './RecordingManualChangesResponseFieldsRecordingVersion';

/**
 * 
 * @export
 * @interface ReleaseManualChangesResponseFields
 */
export interface ReleaseManualChangesResponseFields {
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingTitle}
     * @memberof ReleaseManualChangesResponseFields
     */
    releaseTitle?: RecordingManualChangesResponseFieldsRecordingTitle;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingTitle}
     * @memberof ReleaseManualChangesResponseFields
     */
    dateReleased?: RecordingManualChangesResponseFieldsRecordingTitle;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingTitle}
     * @memberof ReleaseManualChangesResponseFields
     */
    format?: RecordingManualChangesResponseFieldsRecordingTitle;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingTitle}
     * @memberof ReleaseManualChangesResponseFields
     */
    mediaType?: RecordingManualChangesResponseFieldsRecordingTitle;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingVersion}
     * @memberof ReleaseManualChangesResponseFields
     */
    releaseLabels?: RecordingManualChangesResponseFieldsRecordingVersion;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingVersion}
     * @memberof ReleaseManualChangesResponseFields
     */
    catNumbers?: RecordingManualChangesResponseFieldsRecordingVersion;
}

/**
 * Check if a given object implements the ReleaseManualChangesResponseFields interface.
 */
export function instanceOfReleaseManualChangesResponseFields(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReleaseManualChangesResponseFieldsFromJSON(json: any): ReleaseManualChangesResponseFields {
    return ReleaseManualChangesResponseFieldsFromJSONTyped(json, false);
}

export function ReleaseManualChangesResponseFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReleaseManualChangesResponseFields {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseTitle': !exists(json, 'releaseTitle') ? undefined : RecordingManualChangesResponseFieldsRecordingTitleFromJSON(json['releaseTitle']),
        'dateReleased': !exists(json, 'dateReleased') ? undefined : RecordingManualChangesResponseFieldsRecordingTitleFromJSON(json['dateReleased']),
        'format': !exists(json, 'format') ? undefined : RecordingManualChangesResponseFieldsRecordingTitleFromJSON(json['format']),
        'mediaType': !exists(json, 'mediaType') ? undefined : RecordingManualChangesResponseFieldsRecordingTitleFromJSON(json['mediaType']),
        'releaseLabels': !exists(json, 'releaseLabels') ? undefined : RecordingManualChangesResponseFieldsRecordingVersionFromJSON(json['releaseLabels']),
        'catNumbers': !exists(json, 'catNumbers') ? undefined : RecordingManualChangesResponseFieldsRecordingVersionFromJSON(json['catNumbers']),
    };
}

export function ReleaseManualChangesResponseFieldsToJSON(value?: ReleaseManualChangesResponseFields | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'releaseTitle': RecordingManualChangesResponseFieldsRecordingTitleToJSON(value.releaseTitle),
        'dateReleased': RecordingManualChangesResponseFieldsRecordingTitleToJSON(value.dateReleased),
        'format': RecordingManualChangesResponseFieldsRecordingTitleToJSON(value.format),
        'mediaType': RecordingManualChangesResponseFieldsRecordingTitleToJSON(value.mediaType),
        'releaseLabels': RecordingManualChangesResponseFieldsRecordingVersionToJSON(value.releaseLabels),
        'catNumbers': RecordingManualChangesResponseFieldsRecordingVersionToJSON(value.catNumbers),
    };
}

